import classNames from "classnames";
import { format } from "date-fns";
import QRCode from "qrcode.react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { getCaseForSlide } from "app/actions/slideActions";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { useSelectedLabStation } from "hooks/useSelectedLabStation";
import { truncatePatientName } from "util/patientUtils";
import { labelForSlide } from "util/slideUtils";

const ZebraPrintPage = () => {
  const dispatch = useAppDispatch();
  const singlePage = useAppSelector((state) =>
    selectFeatureFlag(state, "singlePageBarcodePrinting")
  );
  const { printer, slide_id } = useParams();
  const slideId = Number(slide_id);
  const selectedLabStationId = useSelectedLabStation().id;
  const slideCase = useAppSelector((sys) => sys.case);
  const slide = slideCase?.slides?.find((s) => s.id === slideId);
  const slideStain = useAppSelector(
    ({ stains }) => stains[slide?.stain_id || 0]
  );

  useEffect(() => {
    if (slideId) {
      dispatch(
        getCaseForSlide({
          id: slideId,
          parentLookupLabStationId: selectedLabStationId,
        })
      );
    }
  }, [slideId]);

  useEffect(() => {
    if (window.opener) {
      const closeWindow = (_e: Event) => {
        window.close();
      };
      window.addEventListener("afterprint", closeWindow);

      return () => {
        window.removeEventListener("afterprint", closeWindow);
      };
    }
  }, []);

  useEffect(() => {
    if (window.opener && slide?.id && slideCase?.id) {
      const print = () => {
        setTimeout(() => window.print(), 250);
      };
      if (document.readyState === "complete") {
        print();
      } else {
        window.addEventListener("load", print);
        return () => window.removeEventListener("load", print);
      }
    }
  }, [slide, slideCase]);

  return slide && slideCase ? (
    <div className={classNames("Print", { SinglePagePrint: singlePage })}>
      <div
        className={`DecoratedBarcode DecoratedBarcode--slide DecoratedBarcode--${printer}`}
      >
        <div className="SlideBarcode">
          <div>
            <header>
              <p className="SlideBarcode__patient">
                <strong>{slideCase.accession}</strong>
              </p>
              {/* <img src="/pw-logo.svg" alt="PathologyWatch" /> */}
            </header>
            <p>{truncatePatientName(slideCase?.patient)}</p>
          </div>
          <figure>
            <QRCode
              value={`slide-${slide?.id}`}
              size={32}
              bgColor={"#ffffff"}
              fgColor={"var(--black)"}
              level={"L"}
              includeMargin={false}
              renderAs={"svg"}
            />
            <figcaption>
              <p>{labelForSlide(slide, slideCase)}</p>
              <p>{slideStain?.abbreviation}</p>
              {slide.created_at && (
                <p>{format(new Date(slide.created_at), "MM/dd/yy")}</p>
              )}
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  ) : (
    <>loading...</>
  );
};

export default ZebraPrintPage;
